import routes from '../routes';
import reducer from './reducers/index';
import * as erfSelectors from './selectors';
import * as erfOperations from './operations';
import * as erfActions from './actions';

export {
    erfSelectors,
    erfOperations,
    erfActions
};

export default {
    routes,
    reducer
};
